import { render, staticRenderFns } from "./PostPurchaseOptionModal.vue?vue&type=template&id=bf38689a"
import script from "./PostPurchaseOptionModal.vue?vue&type=script&lang=js"
export * from "./PostPurchaseOptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports